import type { FaireOrderEntity } from "../../entity_types/order";

export const T9CZGD3R75: FaireOrderEntity = {
  token: "T9CZGD3R75",
  type: "order",
  orderNumber: "#T9CZGD3R75",
  status: "fulfilled",
  totalDollars: 108,
  customerName: "Harbor Lane Home Goods",
  firstOrder: false,
  placedAt: "Dec 1, 2025",
  shipBy: "Sep 22, 2025",
  sourceLabel: "Faire Direct",
  payoutDate: "Pending Ship",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
